// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__hIPns","main":"MainLayout_main__Xg2cg","collapsed":"MainLayout_collapsed__VQggq"};